import _ from 'lodash'
import * as partials from './partials'
import { notifications, forms, skins, api, workflow } from 'src/vuex/getters.js'
import { Submit } from 'src/services/resources'
import {
  addForm,
  addNotification,
  showNotifications,
  updateForm,
  clearAllNotifications
} from 'src/vuex/actions.js'

export default {
  data () {
    return {
      processing: false,
      uid: this.$parent.uid,
      show: false
    }
  },
  computed: {
    form () {
      return _.find(this.forms, ['uid', this.uid])
    },

    index () {
      return _.findIndex(this.forms, ['uid', this.uid])
    },

    headers () {
      let workflow = _.find(this.workflow, ['uid', this.uid])
      return {
        headers: {
          'X-FORMID': workflow.fid,
          'X-FINGERPRINT': workflow.fingerprint,
          'X-SITEID': this.fdata.siteId || workflow.sid
        }
      }
    },

    disabled () {
      if (_.includes(['jump', 'back'], this.fdata.actions[0])) return false
      let errors = _.filter(this.notifications, ['type', 'error'])
      return errors.length > 0
    }
  },

  partials: partials,
  props: ['fdata'],

  vuex: {
    getters: {
      notifications,
      workflow,
      forms,
      api,
      skins
    },
    actions: {
      showNotifications,
      addNotification,
      addForm,
      updateForm,
      clearAllNotifications
    }
  },
  methods: {
    setDbKey (key, actions) {
      this.fdata.dbWorkflowKey = key
      this.click(actions)
    },

    compile (response) {
      let {data} = response
      return _.set(data, 'fields', this.format(data.fields))
    },

    format (data) {
      return _.map(data, x => {
        x = (x.type !== 'type_contentGroup') ? x : _.set(x, 'type', `${x.class}`)
        return _.isNil(x.content) ? x : _.set(x, 'content', this.format(x.content))
      })
    },

    update (data) {
      this.updateForm({
        uid: this.uid,
        workflow: this.fdata.workflowId,
        form: data,
        siteid: this.form.siteid
      }, this.index)
    },

    failed (res) {
      // this.clear(this.uid)
      this.$dispatch('loader::spinner', false)
      this.$set('processing', false)
      let msg = _.has(res.data, 'user_message') ? res.data.user_message : 'Internal error'
      this.addNotification({type: 'error',
                            msg: [msg],
                            id: _.uniqueId(),
                            timeout: 5000,
                            onComplete: 'remove',
                            show: true})
    },

    /**
     * What the button should do based on the action stored in VUEX
     */
    click (action) {
      this.$dispatch('fdata::submit')
      if (this.disabled) {
        // this.showNotifications('error')
        this.$dispatch('fdata::validate')
        return false
      }
      if (_.isObject(this.fdata.dbWorkflowKey)) {

      } else {
        this.submit()
      }
    },

    success (res) {
      let openAs = _.eq(this.fdata.openAs, '') ? 'normal' : this.fdata.openAs
      let evt = {'top': 'set::workflow',
                 'normal': 'add::workflow',
                 'popUp': 'modal::workflow',
                 'newWindow': 'tab::workflow'}
      this.clearAllNotifications()
      let {data} = res
      let workflow = _.isUndefined(data.content) ? data : res.data.content
      workflow.fingerprint = data.fingerprint
      this.$dispatch(evt[openAs], workflow)
    },

    submit () {
      this.processing = true
      let formData = !_.isNil(this.form.data) ? this.form.data : {}
      formData.button = this.fdata.buttonId
      this.$dispatch('loader::spinner', true)
      Submit.post(formData, this.headers)
        .then(this.success)
        .catch(this.failed)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/buttons/_shared/traits.js